import React from 'react';
import { useSelector } from 'react-redux';
import AIAssistant from '../../components/AIAssistant';
import OrbyLogin from './OrbyLogin';

// Página standalone do Orby (item 3): abre SOMENTE o chat do Orby em tela cheia.
// - Rota pública /orby que cuida da própria autenticação: se o usuário não está
//   logado, mostra um login com a cara do Orby (sem revelar o AloDesk); se está,
//   mostra o Orby em tela cheia.
// - Usa a conta AloDesk do usuário e as MESMAS configs de IA (reaproveita o
//   componente AIAssistant e o backend /ai-assistant/chat). Sem sidebar/header.
const OrbyPage = () => {
  const currentUser = useSelector((s) => s.user?.currentUser);
  let stored = null;
  try {
    stored = JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    stored = null;
  }
  const authed = !!(localStorage.getItem('token') && (currentUser?.id || stored?.id));

  return authed ? <AIAssistant open fullScreen onClose={() => {}} /> : <OrbyLogin />;
};

export default OrbyPage;
